/**
 * Unit conversion utilities for FBA Inbound v2024
 *
 * Amazon FBA API expects:
 * - Dimensions in millimeters (mm)
 * - Weight in grams (gm)
 *
 * UI displays:
 * - Dimensions in centimeters (cm)
 * - Weight in kilograms (kg)
 */

// Dimension conversions
export const cmToMm = (cm) => Math.round(cm * 10);
export const mmToCm = (mm) => mm / 10;

// Weight conversions
export const kgToGm = (kg) => Math.round(kg * 1000);
export const gmToKg = (gm) => gm / 1000;

// Convert box dimensions for API submission
export const boxDimensionsToApi = ({ length, width, height }) => ({
  length_mm: cmToMm(length),
  width_mm: cmToMm(width),
  height_mm: cmToMm(height)
});

// Convert box dimensions from API response
export const boxDimensionsFromApi = ({ length_mm, width_mm, height_mm }) => ({
  length: mmToCm(length_mm),
  width: mmToCm(width_mm),
  height: mmToCm(height_mm)
});

// Convert box weight for API submission
export const boxWeightToApi = (weightKg) => ({
  weight_gm: kgToGm(weightKg)
});

// Convert box weight from API response
export const boxWeightFromApi = (weight_gm) => gmToKg(weight_gm);

// Full box conversion for API
export const boxToApi = (box) => ({
  ...boxDimensionsToApi({
    length: box.length,
    width: box.width,
    height: box.height
  }),
  ...boxWeightToApi(box.weight)
});

// Full box conversion from API
export const boxFromApi = (apiBox) => ({
  length: mmToCm(apiBox.length_mm || apiBox.length),
  width: mmToCm(apiBox.width_mm || apiBox.width),
  height: mmToCm(apiBox.height_mm || apiBox.height),
  weight: gmToKg(apiBox.weight_gm || apiBox.weight)
});

export default {
  cmToMm,
  mmToCm,
  kgToGm,
  gmToKg,
  boxDimensionsToApi,
  boxDimensionsFromApi,
  boxWeightToApi,
  boxWeightFromApi,
  boxToApi,
  boxFromApi
};
